import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "data-testid"];
import React from 'react';
import ReactCurrencyInput from 'react-currency-input-field';

var WrappedCurrencyInput = function WrappedCurrencyInput(_ref) {
  var onChange = _ref.onChange,
      dataTestId = _ref['data-testid'],
      passedProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ReactCurrencyInput, _extends({
    "data-testid": dataTestId,
    prefix: "Rp",
    decimalSeparator: ",",
    groupSeparator: ".",
    onValueChange: function onValueChange(value) {
      return onChange === null || onChange === void 0 ? void 0 : onChange(value);
    },
    className: "ant-input"
  }, passedProps));
};

WrappedCurrencyInput.parse = function (value) {
  if (typeof value === 'number') {
    return value;
  }

  if (!value) return null;
  return parseFloat(value.replace(',', '.'));
};

export default WrappedCurrencyInput;